import { defineMessages } from 'react-intl';

export default defineMessages({
  issuesFetching: {
    id: 'app.components.TurnIssuesButton.issuesFetching',
    defaultMessage: 'Issues',
  },
  noIssues: {
    id: 'app.components.TurnIssuesButton.noIssues',
    defaultMessage: 'No Issues',
  },
  showIssues: {
    id: 'app.components.TurnIssuesButton.showIssues',
    defaultMessage: 'Issues ({issueCount})',
  },
  ok: {
    id: 'app.components.TurnIssuesButton.ok',
    defaultMessage: 'ok',
  },
  NoTurnLeader: {
    id: 'app.components.TurnIssuesButton.NoTurnLeader',
    defaultMessage: 'No team leader',
  },
  MultipleTurnLeaders: {
    id: 'app.components.TurnIssuesButton.MultipleTurnLeaders',
    defaultMessage: 'Multiple team leaders',
  },
  NoSpeakerAssigned: {
    id: 'app.components.TurnIssuesButton.NoSpeakerAssigned',
    defaultMessage: 'No speaker of this language assigned',
  },
  EmptyTeam: {
    id: 'app.components.TurnIssuesButton.EmptyTeam',
    defaultMessage: 'No assignees',
  },
  SeparatedFromPartner: {
    id: 'app.components.TurnIssuesButton.SeparatedFromPartner',
    defaultMessage: 'Partners assigned to different routes ({publisherName})',
  },
  DoubleShiftAssigned: {
    id: 'app.components.TurnIssuesButton.DoubleShiftAssigned',
    defaultMessage: '{publisherName} is assigned on consecutive shifts',
  },
  ApplicationForMultipleShiftsNotRespected: {
    id: 'app.components.TurnIssuesButton.ApplicationForMultipleShiftsNotRespected',
    defaultMessage:
      'Application of {publisherName} for multiple shifts not respected',
  },
  ConsecutiveAssignmentsOnDifferentRoutes: {
    id: 'app.components.TurnIssuesButton.ConsecutiveAssignmentsOnDifferentRoutes',
    defaultMessage:
      '{publisherName} is assigned consecutively on different routes',
  },
  NoVehicleAvailable: {
    id: 'app.components.TurnIssuesButton.NoVehicleAvailable',
    defaultMessage: 'No publisher with available vehicle assigned',
  },
  NoBackupTurnLeader: {
    id: 'app.components.TurnIssuesButton.NoBackupTurnLeader',
    defaultMessage: 'No backup turn leader assigned',
  },
  TeamTooSmall: {
    id: 'app.components.TurnIssuesButton.TeamTooSmall',
    defaultMessage: 'Not enough publishers assigned',
  },
  TeamTooLarge: {
    id: 'app.components.TurnIssuesButton.TeamTooLarge',
    defaultMessage: 'Number of assignees exceeds the limit',
  },
  MalePublishersNeeded: {
    id: 'app.components.TurnIssuesButton.MalePublishersNeeded',
    defaultMessage: 'Not enough brothers assigned',
  },
  NotEnoughMentorsAssigned: {
    id: 'app.components.TurnIssuesButton.NotEnoughMentorsAssigned',
    defaultMessage: 'Not enough mentors assigned',
  },
  InvalidTurnLeader: {
    id: 'app.components.TurnIssuesButton.InvalidTurnLeader',
    defaultMessage: '{publisherName} is not allowed to lead a team',
  },
  NonActivePublisher: {
    id: 'app.components.TurnIssuesButton.NonActivePublisher',
    defaultMessage: '{publisherName} is not an active publisher',
  },
  AssignmentRestrictionViolated: {
    id: 'app.components.TurnIssuesButton.AssignmentRestrictionViolated',
    defaultMessage: '{publisherName} is not approved for this route',
  },
  AssignedToMultipleShiftsOnSameDay: {
    id: 'app.components.TurnIssuesButton.AssignedToMultipleShiftsOnSameDay',
    defaultMessage:
      '{publisherName} is assigned to multiple shifts on the same day',
  },
  RoutePreferenceNotRespected: {
    id: 'app.components.TurnIssuesButton.RoutePreferenceNotRespected',
    defaultMessage: 'Assignment to disfavored route',
  },
});
